import { useState, useEffect, useRef } from 'react'
import { getLeamSummaryData } from 'services/leam.service'
import { useAuth } from 'auth/AuthContext'

export const useLeamData = (dateRange = null) => {
  const { user } = useAuth()
  const currentRequestKey = useRef(null)

  const [leamData, setLeamData] = useState({
    agroDataToday: [],
    agroDataYesterday: [],
    agroDataGroupsMonitor: [],
    agroDataGroupsMonitorYesterday: [],
    agroDataLast7Days: [],
    agroDataLast30Days: [],
    pickingDataToday: [],
    pickingDataYesterday: [],
    pickingDataLast7Days: [],
    pickingDataLast30Days: [],
    packingDataToday: [],
    packingDataYesterday: [],
    packingDataLast7Days: [],
    packingDataLast30Days: [],
    workersByGroupYesterday: [],
    loading: true,
    error: null
  })

  const fetchLeamSummaryData = async (rangeToFetch = dateRange) => {
    if (!user?.farmId) return

    try {
      setLeamData(prev => ({ ...prev, loading: true, error: null }))
      const data = await getLeamSummaryData(user.farmId, rangeToFetch)

      setLeamData(prev => ({
        ...prev,
        agroDataToday: data.agroDataToday || [],
        agroDataYesterday: data.agroDataYesterday || [],
        agroDataGroupsMonitor: data.agroDataGroupsMonitor || [],
        agroDataGroupsMonitorYesterday: data.agroDataGroupsMonitorYesterday || [],
        agroDataLast7Days: data.agroDataLast7Days || [],
        agroDataLast30Days: data.agroDataLast30Days || [],
        pickingDataToday: data.pickingDataToday || [],
        pickingDataYesterday: data.pickingDataYesterday || [],
        pickingDataLast7Days: data.pickingDataLast7Days || [],
        pickingDataLast30Days: data.pickingDataLast30Days || [],
        packingDataToday: data.packingDataToday || [],
        packingDataYesterday: data.packingDataYesterday || [],
        packingDataLast7Days: data.packingDataLast7Days || [],
        packingDataLast30Days: data.packingDataLast30Days || [],
        workersByGroupYesterday: data.workersByGroupYesterday || [],
        loading: false
      }))
    } catch (error) {
      console.error('Error fetching LEAM summary:', error)
      setLeamData(prev => ({
        ...prev,
        loading: false,
        error: 'Failed to load LEAM summary data'
      }))
    }
  }

  useEffect(() => {
    const requestKey = JSON.stringify({ farmId: user?.farmId, dateRange })
    if (currentRequestKey.current === requestKey) return
    currentRequestKey.current = requestKey
    fetchLeamSummaryData()
  }, [user?.farmId, dateRange])

  return { leamData, refetch: fetchLeamSummaryData }
}
